import React, { Component } from "react";
import { IPropsIcone } from "../../modelo/Icone";
import IconeAM from "./IconeAM";
import IconePeticaoSubscrito from "./IconePeticaoSubscrito";
import IconeHermesSobrescrito from "./IconeHermesSobrescrito";
import IconeErroSobrescrito
    from "@/img/icones/IconeErroSobrescrito";
import IconeWarningSobrescrito
    from "@/img/icones/IconeWarningSobrescrito";
interface IPropsIconeDespacho extends IPropsIcone {
    peticao?: boolean;
    hermes?: boolean;
    warningPubliquese?: boolean;
}

class IconeDespacho extends Component<IPropsIconeDespacho> {

    render() {
        return (
            <>
                {this.props.hermes && <IconeHermesSobrescrito />}
                {this.props.peticao && <IconePeticaoSubscrito />}
                {this.props.warningPubliquese && <IconeWarningSobrescrito />}
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" style={{ fill: this.props.color || 'currentColor' }}>
                    <path d="M4.3378906 1.5566406v7.5898438L1.001953 12.113281.9375 22.736328H23V12.115234l-3.337891-2.9687496V1.5566406zm1.96875 1.966797H17.693359V13.734375L12 16.988281l-5.6933594-3.253906zm-1.96875 8.2558594L4 11.780783 3.7031474 12l-.5937724 2.173828L12 19.253906l8.890625-5.080078L20.382784 12 20 11l-.337891.78125 1.371094 1.216797v7.478515H2.966797v-7.478515z" />
                    <path d="M7.548241 5.3665114h5.5647v.48754h-5.5647zm0 1.9501602h8.903518v.4875402H7.548241zm0 1.950161h8.903518v.48754H7.548241zm0 1.9501574h8.903518v.487539H7.548241zm0 1.950159h8.903518v.48754H7.548241z" />
                </svg>
            </>
        );
    }
}

export default IconeDespacho;
